var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blue delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4163 10.5417V16.2917M9.58301 10.5417V16.2917M5.74967 6.70833V18.2083C5.74967 18.7167 5.95161 19.2042 6.31105 19.5636C6.6705 19.9231 7.15801 20.125 7.66634 20.125H15.333C15.8413 20.125 16.3288 19.9231 16.6883 19.5636C17.0477 19.2042 17.2497 18.7167 17.2497 18.2083V6.70833M3.83301 6.70833H19.1663M6.70801 6.70833L8.62467 2.875H14.3747L16.2913 6.70833",
    stroke: "#213867",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDelete);
export default __webpack_public_path__ + "static/media/blue-delete.f3892f872e99e1812930f1d7bb141f79.svg";
export { ForwardRef as ReactComponent };